




















import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";
import {
  GetReportPdfStandardList,
  DeleteReportPdfStandard
} from "@/api/reportSetting";
import standAddOrEdit from "./standAddOrEdit.vue";

@Component({
  components: { standAddOrEdit }
})
export default class extends AbpBase {
  @Prop() value: boolean;
  tableData: any = [];
  loading = false;
  showAddOrEdit = false;
  addOrEditData: any = {};
  columns = [
    {
      title: "规格编码",
      key: "standardCode"
    },
    {
      title: "宽度（mm）",
      key: "width"
    },
    {
      title: "高度（mm）",
      key: "height"
    },
    {
      title: "操作",
      width: 175,
      render: (h1: any, p: any) => {
        const h = this.$createElement;
        return h("div", [
          h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              style: {
                marginRight: "10px"
              },
              on: {
                click: () => {
                  this.edit(p.row);
                }
              }
            },
            "编辑"
          ),
          h(
            "Button",
            {
              props: {
                type: "error",
                size: "small"
              },
              on: {
                click: () => {
                  this.del(p.row);
                }
              }
            },
            "删除"
          )
        ]);
      }
    }
  ];

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }

  cancel() {
    this.$emit("input", false);
  }

  created() {
    this.getData();
  }

  async getData() {
    this.loading = true;
    let res = await GetReportPdfStandardList();
    this.tableData = res.objects;
    this.loading = false;
  }

  add() {
    this.addOrEditData = {
      mode: "add",
      data: {}
    };
    this.showAddOrEdit = true;
  }

  edit(row: any) {
    this.addOrEditData = {
      mode: "edit",
      data: row
    };
    this.showAddOrEdit = true;
  }

  del(row: any) {
    this.$Modal.confirm({
      title: "提示",
      content: "确定要删除吗？",
      onOk: async () => {
        await DeleteReportPdfStandard(row.id);
        this.getData();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/tool/reportSetting/stand.vue